<template>
  <span>Click here to compare prices from over {{ numberOfProviders }} other providers to help you find a great deal!</span>
</template>

<script>
export default {
  name: 'broker-solution-more-quotes-text',
  inject: ['productName', 'constants'],
  computed: {
    numberOfProviders () {
      return this.constants.BROKER_SOLUTION_OTHER_PROVIDERS_COUNT[this.productName];
    },
  },
};
</script>
